import { Modal } from 'react-bootstrap';
import Button from '../../../sf-components/Button/Button';
import ButtonStyles from '../../../sf-components/Button/ButtonStyles';
import TextInput from '../../../sf-components/TextInput/TextInput';
import { httpPost } from '../../../utils';
import { useState } from 'react';
import { Label } from '@silverfort/sf-components';

const CreateBackup = ({ onCreate, onClose, show, towerVersion, backupPasswordInfo, getBackupPasswordError }) => {
    const [password, setPassword] = useState();
    const [fileName, setFileName] = useState();
    const [error, setError] = useState();

    const createBackup = () => {
        const error = getBackupPasswordError(password);
        if (error) {
            setError(error);
            return;
        }
        onCreate(httpPost('/Settings/CreateSystemBackup', { password: password, fileName: fileName }));
    };


    return (
        <Modal
            className="font-sf flex flex-col justify-center"
            id={'createBackup'}
            dialogClassName="w-[360px] h-fit [&_.modal-content]:rounded-lg [&_.modal-content]:shadow-modal-light"
            show={show}
            onHide={onClose}
            keyboard={false}
            backdrop="static">
            <Modal.Header className="border-hidden pt-4 pr-6 pb-0 pl-0" closeButton>
                <div className="px-4 pb-4 mb-1 text-14 font-medium text-sf-gray-800">Create Backup File</div>
            </Modal.Header>
            <Modal.Body className="text-13 px-4 pb-6 h-full border-t border-b">
                <div className="flex flex-col gap-2">
                    <div className="grid gap-4">
                        <div className='flex gap-2 flex-col'>
                            <Label text='Rename file (optional)'/>
                            <TextInput
                                className="w-full"
                                onChange={setFileName}
                                value={fileName}
                            />
                        </div>
                        <div className='flex gap-2 flex-col'>
                            <Label text='Add password' mandatory tooltipInfo={backupPasswordInfo}/>
                            <TextInput
                                type="password"
                                className="w-full"
                                onChange={val => {
                                    setError();
                                    setPassword(val)
                                }}
                                value={password}
                                required={true}
                            />
                            {error && <div className="text-10 text-red-600">{error}</div>}
                        </div>
                    </div>
                    <div className="text-xs font-normal text-sf-gray-500">Version: {towerVersion}</div>
                </div>
            </Modal.Body>
            <Modal.Footer className="border-hidden px-6">
                <div className="flex justify-end items-center">
                    <Button
                        onClick={onClose}
                        text={'Cancel'}
                        buttonStyle={ButtonStyles.TertiarySolid}
                        className={'mr-2'}
                    />
                    <Button
                        disabled={!password}
                        buttonStyle={ButtonStyles.PrimarySolid}
                        onClick={createBackup}
                        text={'Backup'}
                    />
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateBackup;
